import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";

import { UiService } from '@services/ui.service';
import { SimulationService } from '@services/simulation.service';
import { SimulationInfo } from '@classes/simulation/simulation-info';

@Injectable()
export class ReportSimuResolver implements Resolve<SimulationInfo[]> {
    constructor(
        private simuSrv: SimulationService,
        private uiSrv: UiService,
        private router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SimulationInfo[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.simuSrv.getInfoList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            }),
            catchError((error) => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                this.router.navigate(['/']);
                return throwError(error);
            })
        );
    }
}
